import { BudgetComponent, FlattenedRow } from './types';

export const isStage = (component: BudgetComponent): boolean => {
  return component.type === 'stage' || component.type === 'unit_constructive';
};

export const buildTreeFromMap = (
  map: Map<number, BudgetComponent[]>,
  parentId: number,
): BudgetComponent[] => {
  const children = map.get(parentId) || [];

  return children.map((component) => {
    if (!isStage(component)) {
      return {
        ...component,
        children: [],
      };
    }

    return {
      ...component,
      children: buildTreeFromMap(map, component.id),
    };
  });
};

export const flattenTree = (
  tree: BudgetComponent[],
  depth = 0,
  parentRows: FlattenedRow[] = [],
): FlattenedRow[] => {
  return tree.reduce<FlattenedRow[]>((acc, node) => {
    const currentRows = [...acc, { component: node, depth }];

    if (!node.children || node.children.length === 0) {
      return currentRows;
    }

    return flattenTree(node.children, depth + 1, currentRows);
  }, parentRows);
};
